import * as StackBlur from 'stackblur-canvas'

// Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
export default ({
  data,
  wantedWidth,
  wantedHeight,
  blur
}) => new Promise(resolve => {

  // We create an image to receive the Data URI
  const image = document.createElement(`img`)

  // When the event "onload" is triggered we can resize the image.
  image.onload = () => {
    // We create a canvas and get its context.
    const canvas = document.createElement(`canvas`)
    const context = canvas.getContext(`2d`)

    // We set the dimensions at the wanted size.
    canvas.width = wantedWidth
    canvas.height = wantedHeight

    // We resize the image with the canvas method drawImage()
    context.drawImage(image, 0, 0, wantedWidth, wantedHeight)
    StackBlur.canvasRGB(canvas, 0, 0, wantedWidth, wantedHeight, blur)

    resolve(canvas.toDataURL())
  }
  // We put the Data URI in the image`s src attribute
  image.src = typeof data === `string`
    ? data
    : URL.createObjectURL(data)
})
